/** Cross-tab + same-window hint so public site refetches overrides quickly after admin changes. */
export const CONTENT_RELOAD_KEY = "sd_content_reload";

export function notifyContentChanged() {
  try {
    localStorage.setItem(CONTENT_RELOAD_KEY, String(Date.now()));
  } catch {
    /* private mode / quota */
  }
  window.dispatchEvent(new CustomEvent("sd-content-reload"));
}
